import { Component,Inject, Input, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import {_} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore } from "../../data-stores/mysynch.datastore";
import { BroadCastService } from "../../services/broadcast.service";
import { MySynchEnumerationService } from "../../services/mysynch.enumeration.service";
import { PerformanceMetricsService } from "../../services/performance-metrics.service";

@Component({
    standalone: false,
    selector:"navigation-section",
    templateUrl: "../app/navigation/navigation-section/navigation-section.view.html",
})
export class NavigationSection implements OnInit, AfterViewInit, OnDestroy {

    @Input() sectionView:any;
    private _:any;
    private numFarms:any = 1;
    private currentHerd:any = this.MSF.getActiveHerd();
    private hasOnlyNonDC305Farms:boolean = false;
    private isSuperAdmin:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
	private isTM:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
    private isParnellViewer:any = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','PARNELL_VIEWER'));
	private isUser:any = (!this.isSuperAdmin && !this.isTM && !this.isParnellViewer) ? true : false;
    private isMobile:boolean = this.deviceDetector.isMobile();

    private noRedirectPages:any = ['Login', 'Welcome', 'WelcomeToFarm', 'ForgotPassword', 'PasswordReset','User','Alerts','NewJournal','JournalEdit','Definitions','Help'];

    // subscriptions and deregistrations
    private onUpdateNavigationSubscription:any;
    

    constructor(@Inject('MySynchFactory') private MSF:any, 
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                @Inject('F360Constant') private constant:any,
                //@Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ) {
        
            this._ = _;
       
    }

    private onClickNavLink(link){
        if(this.isMobile){
            this.broadCastSrv.toggleNavigationMsg("");
        }
        var action = _.get(link,'action');
        if(!_.isUndefined(action)){
           var actionSource = _.get(action,'source') as string;
           var actionFunction = _.get(action,'function') as string;
           if(!_.isUndefined(actionSource) && !_.isUndefined(actionFunction)){
              var source = (_.isEqual(actionSource,"self")) ? this : this[actionSource];
              source[actionFunction]();
           }

        }
        var pageType = _.get(link,'pageType') as string;
        this.mysynchDataStore.setCurrentPageType(pageType);
        var state = _.get(link,'stateName');
        if(!_.isUndefined(state) && !_.isEmpty(state)){
            this.MSF.loadPage(state);
        }
    }

    private checkRole(requiredRoles){
        return !requiredRoles || this.viewAuth.hasRole(requiredRoles)
    }
    private checkRolePermission(requiredPermission) {
        return !requiredPermission || this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumerationName("Permission",requiredPermission));
    };
    private checkHerdSofwarePermission(allowedHerdSoftware){
        return this.viewAuth.hasHerdSoftwarePermission(allowedHerdSoftware);
    };
    private checkFarmInBeta(requiredBetas){
        return this.viewAuth.farmIsInBeta(requiredBetas);
    };

    private getFilteredNavLinksByPermisson() {
        return _.filter(this.sectionView.navLinks,(navLink:any) => {
            return (_.compact(_.map(_.map(navLink.dropdown, 'permission'), this.checkRolePermission)).length || this.checkRolePermission(navLink.permission))
                && this.checkHerdSofwarePermission(_.get(navLink,'allowedHerdSoftware'));
        });
    };

    private checkCurrentPageIsInNavigation(){
        var navLinkStates = [];
                var statesInSectionNavLinks = _.map(_.get(this.sectionView,'navLinks',[]),(navLink)=>_.pick(navLink,["isHidden","stateName"]));
                var statesInSubMenuNavLinks = _.flattenDeep(
                                                    _.map(_.cloneDeep(_.get(this.sectionView,'submenus',[])),(submenu)=>{
                                                        return _.map(_.get(submenu,'navLinks',[]),(navLink)=>_.pick(navLink,["isHidden","stateName"]));
                                                    })
                                              );
                navLinkStates.push(statesInSectionNavLinks)
                navLinkStates.push(statesInSubMenuNavLinks);
        
         navLinkStates = _.uniq(_.compact(_.flattenDeep(navLinkStates)));

         if(   !_.isEmpty(this.MSF.state.current.name)
            && _.includes(_.pluck(navLinkStates,"stateName"),this.MSF.state.current.name)
            && !_.any(navLinkStates,(navLinkState)=>{ return _.isEqual(this.MSF.state.current.name,_.get(navLinkState,'stateName')) && !_.get(navLinkState,'isHidden',false)}) 
            && !_.includes(this.noRedirectPages,this.MSF.state.current.name) 
            && !_.includes(this.MSF.adminStates,this.MSF.state.current.name))
         {
            this.redirectToHomepage();
         }
    }

    private redirectToHomepage(){
        var homepage =  this.MSF.getUserHomepageStateName()
        this.MSF.loadPage(homepage);      
    }
    private setOrUpdateNavDeterminationProperties(){
        this.currentHerd = this.MSF.getActiveHerd();
        this.isSuperAdmin = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'));
        this.isTM = this.viewAuth.hasRole(this.mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'));
        this.isUser = (!this.isSuperAdmin && !this.isTM) ? true : false;
        var availableFarms = this.MSF.getAvailableFarms();
        this.numFarms = _.get(availableFarms,"length",1);
        this.hasOnlyNonDC305Farms = this.MSF.userHasOnlyNonDC305Farms();
    }

    private updateSectionView(sectionType:string){
                 
        switch (sectionType) {
            case "MultiFarm":       
                if(_.isEqual(this.numFarms,1) || this.hasOnlyNonDC305Farms){
                    _.set(this.sectionView,'isHidden',true);
                }else{
                    _.set(this.sectionView,'isHidden',false);
                }
                     
                break;
            case "SingleFarm": 
                if(_.isEqual(this.numFarms,1) ){
                    _.set(this.sectionView,'showTitle',false);
                    _.set(this.sectionView,'hideFarmSelect',true);
                }else{
                    _.set(this.sectionView,'showTitle',true);
                    _.set(this.sectionView,'hideFarmSelect',false);
                }

               if(this.hasOnlyNonDC305Farms || !this._.isEqual(_.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'),"DC305")){
                    _.forEach(this.sectionView.submenus,(submenu)=>{
                        if(_.includes(_.get(submenu,'allowedHerdSoftware',[]),"DC305") && !_.includes(_.get(submenu,'allowedHerdSoftware',[]),_.get(this.MSF.getActiveHerd(),'herdMgmtSoftware'))){
                            _.set(submenu,'isHidden',true);
                            _.forEach(_.get(submenu,'navLinks'),(navLink)=>_.set(navLink,'isHidden',true))
                        }
                    })  
                }else{
                    _.forEach(this.sectionView.submenus,(submenu)=>{
                            _.set(submenu,'isHidden',false);
                            _.forEach(_.get(submenu,'navLinks'),(navLink)=>_.set(navLink,'isHidden',false))
                    }) 
                }
                break;
            case "Admin": 
                if(this.isUser){
                    _.set(this.sectionView,'isHidden',true);
                }
                break;
        }
               
        this.checkCurrentPageIsInNavigation();   
    }

    ngOnDestroy(): void {
        if(this.onUpdateNavigationSubscription){
            this.onUpdateNavigationSubscription.unsubscribe();
        }
    }

    ngOnInit(){
       // this.perfMetricSvc.startTiming(`Component:NavigationSection${this.sectionView.name}:Render`);
        this.setOrUpdateNavDeterminationProperties();
        this.onUpdateNavigationSubscription = this.broadCastSrv.onUpdateNavigation()
        .subscribe((msgData)=>{
            var sectionsToUpdate = _.get(msgData,'updateSections', []);
            _.forEach(sectionsToUpdate,(section)=>{
                    
                if(_.isEqual(_.get(section,'name'),_.get(this.sectionView,'name'))){           
                    var sectionType = _.get(section,'sectionType') as string;
                    if(!_.isUndefined(sectionType)){
                        this.setOrUpdateNavDeterminationProperties();
                        this.updateSectionView(sectionType);
                    }
                 }
            }) 
        });
    }

    ngAfterViewInit(){
          this.MSF.ready(()=>{
          //  this.perfMetricSvc.endTiming("component",`Component:NavigationSection${this.sectionView.name}:Render`);
          });
    }

}